import { urls } from "../constants";
import api from "./api";

const addLaboratory = async ({ laboratory }) => {
  try {
    const response = await api.post(urls.addLaboratory, laboratory);
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getLaboratories = async ({ page, limit }) => {
  try {
    const response = await api.get(urls.getLaboratories, {
      params: {
        page: page ? page : 1,
        limit: limit ? limit : 100
      }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getLabsWithoutOperators = async () => {
  try {
    const response = await api.get(urls.getLabsWithoutOperators);
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getLaboratoriesFilter = async ({ text, page, limit }) => {
  try {
    const response = await api.get(urls.getLaboratories, {
      params: {
        text,
        page: page ? page : 1,
        limit: limit ? limit : 100
      }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getChildLaboratories = async ({
  laboratoryId,
  page,
  limit,
  text,
}) => {
  try {
    const response = await api.get(`${urls.getLaboratories}/${laboratoryId}`, {
      params: {
        page: page ? page : 1,
        limit: limit ? limit : 100,
        text
      }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getChildLaboratoriesFilter = async ({
  text,
  page,
  limit,
  laboratoryId,
}) => {
  try {
    const response = await api.get(urls.getChildLaboratoriesFilter, {
      params: {
        laboratoryId,
        text,
        page: page ? page : 1,
        limit: limit ? limit : 100
      }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getPatientAssignProduct = async ({
  laboratoryId,
  text,
  page,
  limit,
}) => {
  try {
    const response = await api.get(urls.getPatientsAssignProducts, {
      params: {
        laboratoryId,
        text,
        page: page ? page : 1,
        limit: limit ? limit : 100
      }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const putOperatorToAssign = async ({ _id, operatorId }) => {
  try {
    const response = await api.put(`${urls.assignOperator}/${_id}`, { operatorId });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getAssignedOperators = async ({
  laboratoryId,
  text,
  page,
  limit,
}) => {
  try {
    const response = await api.get(urls.getAssignedOperators, {
      params: {
        laboratoryId,
        text,
        page: page ? page : 1,
        limit: limit ? limit : 100
      }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getLaboratoryUsers = async ({ laboratoryId }) => {
  try {
    const response = await api.get(urls.getLaboratoryUsers, {
      params: { laboratoryId }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getReports = async ({ laboratoryId, page, limit, text }) => {
  try {
    const response = await api.get(urls.getReports, {
      params: {
        laboratoryId,
        page: page ? page : 1,
        limit: limit ? limit : 100,
        text
      }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const updateReport = async ({ _id }) => {
  try {
    const response = await api.put(`${urls.updateStatusReport}/${_id}`);
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getUnreadReportsQuantity = async ({ laboratoryId }) => {
  try {
    const response = await api.get(urls.getUnreadReportsQuantity, {
      params: { laboratoryId }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const addVisitingZones = async ({ visitingZonesInfo, laboratoryId }) => {
  try {
    const response = await api.post(urls.addVisitingZones, { visitingZonesInfo, laboratoryId });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getVisitingZones = async ({ laboratoryId }) => {
  try {
    const response = await api.get(`${urls.getVisitingZones}/${laboratoryId}`);
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const deleteVisitingZone = async ({ visitingZoneId }) => {
  try {
    const response = await api.get(`${urls.deleteVisitingZone}/${visitingZoneId}`);
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const updateVisitingZone = async ({ visitingZoneInfo }) => {
  try {
    const response = await api.post(urls.updateVisitingZone, { visitingZoneInfo });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getAVisitingZone = async ({ visitingZoneId }) => {
  try {
    const response = await api.get(`${urls.getAVisitingZone}/${visitingZoneId}`);
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const zonifyDoctors = async ({ visitingZoneId, doctors }) => {
  try {
    const response = await api.post(urls.zonifyDoctors, { visitingZoneId, doctors });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const addLabRepresentative = async ({ labRepresentativeInfo }) => {
  try {
    const response = await api.post(urls.addLabRepresentative, { labRepresentativeInfo });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const updateLabRepresentative = async ({ labRepresentativeInfo }) => {
  try {
    const response = await api.post(urls.updateLabRepresentative, { labRepresentativeInfo });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const addManyByFile = async ({ labRepresentativeInfo }) => {
  try {
    const response = await api.post(urls.addManyByFile, labRepresentativeInfo);
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const zonifyDoctorsByFile = async ({ labRepresentativeInfo }) => {
  try {
    const response = await api.post(urls.zonifyDoctorsByFile, labRepresentativeInfo);
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const findLabRepresentativesByLaboratory = async ({ laboratoryId }) => {
  try {
    const response = await api.get(`${urls.findLabRepresentativesByLaboratory}/${laboratoryId}`);
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const findLabRepresentativeById = async ({ labRepresentativeId }) => {
  try {
    const response = await api.get(`${urls.findLabRepresentativeById}/${labRepresentativeId}`);
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const deleteLabRepresentative = async ({ labRepresentativeId }) => {
  try {
    const response = await api.get(`${urls.deleteLabRepresentative}/${labRepresentativeId}`);
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const multizonification = async ({ multizonificationData }) => {
  try {
    const response = await api.post(urls.multizonification, multizonificationData);
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const updateDoctorZones = async ({ updatedDoctorInfo }) => {
  try {
    const response = await api.post(urls.updateDoctorZones, updatedDoctorInfo);
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getAssociatedUsersByLab = async ({ getOptions, laboratoryId }) => {
  try {
    const response = await api.post(`${urls.getAssociatedUsersByLab}/${laboratoryId}`, getOptions);
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const exportDoctors = async () => {
  // try {
  //     const response = await api.get(urls.exportDoctors, { responseType: 'blob' });
  //     return { status: response.status, response: response.data };
  // } catch (error) {
  //      return { status: error.response?.status, response: error.response?.data };
  // }
};

const assignToRepresentativesStocks = async ({
  laboratoryId,
  assignmentsToRepresentativesStocks,
}) => {
  try {
    const response = await api.post(urls.assignToRepresentativesStocks, { laboratoryId, assignmentsToRepresentativesStocks });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const updateDoctorCategory = async ({
  doctorId,
  laboratoryId,
  substituteCategoryId,
}) => {
  try {
    const response = await api.post(urls.updateDoctorCategory, {
      doctorId,
      laboratoryId,
      substituteCategoryId,
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const addDoctorCategory = async ({
  productsRefillCategoryId,
  doctorsToCategorize,
}) => {
  try {
    const response = await api.post(urls.addDoctorCategory, {
      productsRefillCategoryId,
      doctorsToCategorize,
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const deleteDoctorCategory = async ({ doctorId, laboratoryId }) => {
  try {
    const response = await api.post(urls.deleteDoctorCategory, {
      doctorId,
      laboratoryId,
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const addProductsRefillCategories = async ({
  laboratoryId,
  productsRefillCategoryData,
}) => {
  try {
    const response = await api.post(urls.addProductsRefillCategories, {
      newCategoryInfo: { laboratoryId, ...productsRefillCategoryData },
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const editProductsRefillCategories = async ({ data }) => {
  try {
    const response = await api.post(urls.editProductsRefillCategories, data);
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const deleteProductsRefillCategory = async ({
  productRefillCategoryId,
}) => {
  try {
    const response = await api.post(urls.deleteProductsRefillCategory, {
      productsRefillCategoryToDelete: productRefillCategoryId,
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const addBasalCategory = async ({ laboratoryId, basalCategory }) => {
  try {
    const response = await api.post(urls.addBasalCategory, {
      newCategoryInfo: { laboratoryId, ...basalCategory },
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getRefillCategories = async ({ laboratoryId }) => {
  try {
    const response = await api.get(urls.getRefillCategories, {
      params: { laboratoryId }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getDoctorsRefillCategories = async ({ laboratoryId }) => {
  try {
    const response = await api.get(urls.getDoctorsRefillCategories, {
      params: { laboratoryId }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getAllDoctorsRefillCategorization = async ({
  regex,
  page,
  limit,
  laboratoryId,
}) => {
  try {
    const response = await api.get(urls.getAllDoctorsRefillCategorization, {
      params: { laboratoryId, regex, page, limit }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const addInformedConsents = async ({ info }) => {
  try {
    const response = await api.post(urls.addInformedConsents, info);
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const patchInformedConsents = async ({ info }) => {
  try {
    const response = await api.patch(urls.patchInformedConsents, info);
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getInformedConsents = async () => {
  try {
    const response = await api.get(urls.listInformedConsents);
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const downloadSignatories = async ({ consentId }) => {
  try {
    const response = await api.get(urls.downloadSignatories, {
      params: { consentId },
      responseType: 'blob'
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const assignProductsDoctors = async ({ assignments }) => {
  try {
    const response = await api.post(urls.assignProductsDoctors, { assignments });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const assignProductsDoctorsByExcel = async ({ data }) => {
  try {
    const response = await api.post(urls.assignProductsDoctorsByExcel, data);
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const downloadExampleAssignProductsDoctorsByExcel = async () => {
  try {
    const response = await api.get(urls.downloadExampleAssignProductsDoctorsByExcel, {
      responseType: 'blob'
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getUserConsents = async ({ regex }) => {
  try {
    const response = await api.get(urls.getUserConsents, {
      params: { regex }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const downloadSignedSignatories = async ({ consentId, footprint, type }) => {
  let url = `${urls.downloadSignedSignatories}/${footprint}`;
  const params = {};
  if (type === "patient") {
    params.consentId = consentId;
  }

  try {
    const response = await api.get(url, {
      params,
      responseType: 'blob'
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const laboratoryServices = Object.freeze({
  addLaboratory,
  getLaboratories,
  getLaboratoriesFilter,
  getChildLaboratories,
  getChildLaboratoriesFilter,
  getPatientAssignProduct,
  putOperatorToAssign,
  getAssignedOperators,
  getLaboratoryUsers,
  getReports,
  updateReport,
  getUnreadReportsQuantity,
  getLabsWithoutOperators,
  addVisitingZones,
  getVisitingZones,
  deleteVisitingZone,
  updateVisitingZone,
  getAVisitingZone,
  zonifyDoctors,
  addLabRepresentative,
  findLabRepresentativesByLaboratory,
  deleteLabRepresentative,
  updateLabRepresentative,
  findLabRepresentativeById,
  addManyByFile,
  multizonification,
  getAssociatedUsersByLab,
  updateDoctorZones,
  exportDoctors,
  assignToRepresentativesStocks,
  getRefillCategories,
  getDoctorsRefillCategories,
  addProductsRefillCategories,
  addBasalCategory,
  deleteProductsRefillCategory,
  editProductsRefillCategories,
  updateDoctorCategory,
  deleteDoctorCategory,
  addDoctorCategory,
  zonifyDoctorsByFile,
  getAllDoctorsRefillCategorization,
  addInformedConsents,
  patchInformedConsents,
  getInformedConsents,
  downloadSignatories,
  assignProductsDoctors,
  assignProductsDoctorsByExcel,
  downloadExampleAssignProductsDoctorsByExcel,
  getUserConsents,
  downloadSignedSignatories,
});

export default laboratoryServices;
